import { Injectable } from '@angular/core';
import { LogLevel, OpenIdConfiguration, StsConfigLoader } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { Tenant } from 'src/app/shared/models/tenant';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Injectable()
export class PortalAuthConfigLoader extends StsConfigLoader {
  constructor(private appConfigService: AppConfigService) {
    super();
  }

  loadConfigs(): Observable<OpenIdConfiguration[]> {
    return this.appConfigService.tenant$.pipe(
      filter(Boolean),
      take(1),
      map((tenant: Tenant) => {
        const config: OpenIdConfiguration = {
          authority: tenant.portalLoginUri.replace(/\/+$/, ''),
          redirectUrl: `${tenant.portalUri}portal/login`,
          postLogoutRedirectUri: `${tenant.portalUri}portal`,
          clientId: window.location.hostname,
          scope: 'openid profile email api offline_access',
          responseType: 'code',
          silentRenew: true,
          strictIssuerValidationOnWellKnownRetrievalOff: true, //issuer is https://idsrv.lineupportal.com, but URL is https://subdomain.lineupportal.com
          useRefreshToken: true,
          renewTimeBeforeTokenExpiresInSeconds: 60,
          logLevel: window.location.hostname === 'localhost' ? LogLevel.Debug : LogLevel.None
        };
        return [config];
      })
    );
  }
}
